/**
 * Browser-only helper to drop dashboard KPI snapshots from localStorage.
 * Kept separate from the React hook so auth sign-out can call it without
 * creating a client ↔ hooks circular import.
 */

const DASHBOARD_CACHE_PREFIX = 'dashboard:';

export function clearDashboardStatsCache() {
  if (typeof window === 'undefined') return;
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(DASHBOARD_CACHE_PREFIX)) toRemove.push(k);
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}
